import { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";
import { BodyActivityClassroom, getResponseSearchClassRoom, ResponseGetActivityClassroom, ResponsePostActivityClassroom } from "./interfaceActivityClassroom";

export const getActivityClassroom = async (year?: string, sede?: string, level?: string): Promise<ResponseGetActivityClassroom[]> => {
    const queryParams = `${year ? `yearId=${year}` : ''}${sede ? `${year ? '&' : ''}campusId=${sede}` : ''}${level ? `${level ? '&' : ''}levelId=${level}` : ''}`;
    const url = `/activity-classroom/search/params${queryParams ? `?${queryParams}` : ''}`;
    try {
        const data = await getApi(url);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetActivityClassroom[];
    }
}


export const postActivityClassroom = async (body: BodyActivityClassroom): Promise<ResponsePostActivityClassroom> => {
    try {
        const data = await postApi('/activity-classroom', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePostActivityClassroom;
    }
}

export const patchActivityClassroom = async (body: BodyActivityClassroom, id?: number): Promise<ResponseGetActivityClassroom> => {

    try {
        const data = await patchApi(`/activity-classroom/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetActivityClassroom;
    }
}

export const getActivityClassroomId = async (term?: number): Promise<ResponseGetActivityClassroom> => {
    try {
        const data = await getApi(`/activity-classroom/${term}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetActivityClassroom;
    }
}

export const deleteActivityClassroom = async (term: number): Promise<any> => {
    try {
        const data = await deleteApi(`/activity-classroom/${term}`, term);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getActivityClassroomAll = async (): Promise<any> => {
    try {
        const data = await getApi(`/activity-classroom`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getActivitySearchClassroom = async (year?: string, sede?: string, level?: string): Promise<getResponseSearchClassRoom[]> => {
    const queryParams = `${year ? `yearId=${year}` : ''}${sede ? `${year ? '&' : ''}campusId=${sede}` : ''}${level ? `${level ? '&' : ''}levelId=${level}` : ''}`;
    const url = `/activity-classroom/search/classrooms${queryParams ? `?${queryParams}` : ''}`;
    try {
        const data = await getApi(url);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as getResponseSearchClassRoom[];
    }
}


export const getActivityClassroomAscent = async (id: number): Promise<any> => {
    const url = `/activity-classroom/ascent/${id}`;
    try {
        const data = await getApi(url);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


export const getActivityClassroomByClassroom = async (id: number): Promise<any> => {
    const url = `/course/activity-course/by-classroom/${id}`;
    try {
        const data = await getApi(url);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


